import axios from "axios";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Link, useNavigate } from "react-router-dom";

function OtherInfo({ isOpen, onClose, userType }) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [dob, setDob] = useState("");
  const [phone, setPhone] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // 👇 try to read saved user info from localStorage
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        const user = JSON.parse(storedUser);

        if (user.first_name) setFirstName(user.first_name);
        if (user.last_name) setLastName(user.last_name);

        // If backend dob includes time, take only date
        if (user.dob) {
          const formattedDob = user.dob.split(" ")[0]; // "2025-09-18"
          setDob(formattedDob);
        }

        if (user.phone) setPhone(user.phone);

        if (user.country_code) {
          setCountryCode(user.country_code);
        } else {
          setCountryCode(""); // no default
        }
      } catch (e) {
        console.error("Error parsing stored user:", e);
      }
    }
  }, []);

  if (!isOpen) return null;

  const handleClose = () => {
    window.location.reload(); // ⬅️ ONLY HERE reload
    onClose();
  };

  // ✅ Validation function
  const validate = () => {
    let newErrors = {};

    if (!firstName.trim()) newErrors.firstName = "First name is required";
    if (!lastName.trim()) newErrors.lastName = "Last name is required";
    // if (!dob) newErrors.dob = "Date of Birth is required";
    if (!dob) {
      newErrors.dob = "Date of Birth is required";
    } else {
      const today = new Date();
      const birthDate = new Date(dob);
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();

      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--; // adjust if birthday hasn't happened yet this year
      }

      if (age < 18) {
        newErrors.dob = "You must be at least 18 years old";
      }
    }

    if (!phone) {
      newErrors.phone = "Phone number is required";
    } else {
      try {
        // const fullNumber = `${countryCode}${phone}`;  // e.g. +65 65509592
        const fullNumber =
          countryCode && countryCode.startsWith("+")
            ? `${countryCode}${phone}`
            : `+${countryCode}${phone}`;

        const phoneNumber = parsePhoneNumberFromString(fullNumber);

        if (!phoneNumber || !phoneNumber.isValid()) {
          newErrors.phone = "Invalid phone number";
        }
      } catch (e) {
        newErrors.phone = "Invalid phone number";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    try {
      setLoading(true);

      const token = localStorage.getItem("authToken");
      if (!token) {
        setErrors({ api: "No token found. Please login again." });
        return;
      }

      // ✅ Use userType prop instead of localStorage
      let post_url = "user/extra-information";
      if (userType === 2) {
        post_url = "host/extra-information";
      }

      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/${post_url}`,
        {
          first_name: firstName,
          last_name: lastName,
          dob,
          phone,
          country_code: countryCode,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (res.data && res.data.status) {
        localStorage.setItem("user", JSON.stringify(res.data.user));

        const hostProfile =
          res.data.user?.host_profile ?? res.data.host_profile;
        const type = res.data.user?.user_type ?? userType;

        if (type === 2) {
          // Host user
          if (hostProfile === 1) {
            navigate("/listing"); // host already has profile
          } else {
            navigate("/host-category"); // host profile not created
          }
        } else {
          // Normal user
          localStorage.setItem("user", JSON.stringify(res.data.user));
          navigate("/profile");
        }
      } else {
        setErrors({ api: res.data.message || "Failed to save info" });
      }
      onClose();
    } catch (err) {
      setErrors({ api: err.response.data.message });
      const errMsg =
        err.response?.data?.message ||
        "Something went wrong while verifying info";
      toast.error(errMsg);
      // setErrors({ api: "Something went wrong while saving information" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal fade all_modalss show" style={{ display: "block" }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content detailspgess">
          <div className="modal-header">
            <button type="button" className="close" onClick={handleClose}>
              &times;
            </button>
          </div>
          <div className="modal-body">
            <div className="shedow_booox">
              <div className="al_titlss_ara">
                <h3>
                  <Link to="/" className="ar_left">
                    <img src="images/chevron-left.png" alt="" />
                  </Link>{" "}
                  Finishing Signing up
                </h3>
                <p className="discrpss b_tetx">Your information</p>
              </div>

              {/* First Name */}
              <div className="form-group">
                <label>First name</label>
                <input
                  type="text"
                  className="form-control"
                  value={firstName}
                  onKeyPress={(e) => {
                    if (!/^[A-Za-z\s]$/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  maxLength={20}
                  onChange={(e) => setFirstName(e.target.value)}
                />
                {errors.firstName && (
                  <small className="text-danger">{errors.firstName}</small>
                )}
              </div>

              {/* Last Name */}
              <div className="form-group">
                <label>Last name</label>
                <input
                  type="text"
                  className="form-control"
                  value={lastName}
                  onKeyPress={(e) => {
                    if (!/^[A-Za-z\s]$/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  maxLength={20}
                  onChange={(e) => setLastName(e.target.value)}
                />
                {errors.lastName && (
                  <small className="text-danger">{errors.lastName}</small>
                )}
              </div>

              {/* DOB */}
              <div className="form-group">
                <label>Date of Birth</label>
                <input
                  type="date"
                  className="form-control"
                  value={dob}
                  onChange={(e) => setDob(e.target.value)}
                  // max={new Date().toISOString().split("T")[0]}
                  max={
                    new Date(
                      new Date().setFullYear(new Date().getFullYear() - 18),
                    )
                      .toISOString()
                      .split("T")[0]
                  }
                  onClick={(e) => {
                    if (e.target.showPicker) {
                      e.target.showPicker(); // ✅ Opens calendar on click
                    }
                  }}
                />
                {errors.dob && (
                  <small className="text-danger">{errors.dob}</small>
                )}
              </div>

              {/* Phone */}
              <div className="form-group">
                <label>Phone</label>
                <PhoneInput
                  country={"au"}
                  inputClass="form-control"
                  inputStyle={{ width: "100%" }}
                  value={countryCode + phone} // this will show the full number in input
                  onChange={(value, countryData, e, formattedValue) => {
                    const dialCode = countryData.dialCode; // e.g. 91
                    const fullNumber = value; // e.g. 911234567890
                    const apiDialCode = countryCode.replace("+", "");

                    // Remove dialCode from the fullNumber to get only the phone number
                    const onlyNumber = fullNumber.startsWith(apiDialCode)
                      ? fullNumber.slice(apiDialCode.length)
                      : fullNumber;

                    // setCountryCode("+" + dialCode); // ✅ country code only
                    setCountryCode(countryCode || dialCode);
                    setPhone(onlyNumber); // ✅ phone number only
                  }}
                  enableAreaCodes={false}
                  // disableDropdown={true}   // 🚫 user cannot change flag/country
                  // countryCodeEditable={false}
                  disableDropdown={
                    !(!countryCode || countryCode.trim() === "") ? true : false
                  }
                  // 👆 dropdown enabled only when countryCode is null/empty
                  countryCodeEditable={!countryCode}
                />

                {errors.phone && (
                  <small className="text-danger">{errors.phone}</small>
                )}
              </div>

              {errors.api && (
                <div className="alert alert-danger mt-2">{errors.api}</div>
              )}

              <div className="txtxtx text-left sm">
                Here’s the adapted version for Weyfarin Experiences:
                <span className="block">
                  By selecting Agree and continue, I agree to Weyfarin
                  Experiences’{" "}
                  <a
                    href="/term-service"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Terms of Service
                  </a>
                  ,{" "}
                  <a
                    href="/term-service"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Payments Terms of Service
                  </a>
                  , and Non discrimination Policy and acknowledge the{" "}
                  <a
                    href="/privacy-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>
                  .
                </span>
              </div>

              <div className="form-group">
                <button
                  className="btnlinks"
                  type="button"
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  {loading ? "Saving..." : "Continue"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Background overlay */}
      <div className="modal-backdrop fade show" onClick={onClose}></div>
    </div>
  );
}

export default OtherInfo;
